// import React from 'react';

// // List of client logo paths (assuming icons are in public/cicons folder)
// const clientLogos = [
//     'cicons/logo1.png',
//     'cicons/logo2.png',
//     'cicons/logo3.png',
//     'cicons/logo4.png',
//     'cicons/logo5.png',
//     'cicons/logo6.png',
//     'cicons/logo7.png',
//     'cicons/logo8.png',
//     'cicons/logo9.png',
//     'cicons/logo10.png',
//     'cicons/logo11.png',
//     'cicons/logo12.png',
//     'cicons/logo13.png',
//     'cicons/logo14.png',
//     'cicons/logo15.png',
//     'cicons/logo16.png',
// ];

// const SocialProof = () => {
//     return (
//         <div className="bg-gradient-to-r from-blue-50 to-green-50 p-10 rounded-xl mt-12 shadow-2xl">
//             {/* Header Section */}
//             <h3 className="text-4xl font-bold text-gray-900 text-center mb-6 tracking-tight">
//                 Join Our Community of Happy Clients
//             </h3>
//             <p className="text-xl text-gray-700 text-center mb-8">
//                 Over <span className="font-semibold text-primary">20+ satisfied clients</span> have already
//                 trusted us to elevate their business. Let us help you achieve success.
//             </p>

//             {/* Subheading */}
//             <h4 className="text-2xl font-semibold text-gray-800 text-center mb-6">
//                 Our Esteemed Clients
//             </h4>

//             {/* Grid of Client Logos */}
//             <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-6">
//                 {clientLogos.map((logo, index) => (
//                     <div
//                         key={index}
//                         className="flex justify-center items-center bg-white p-4 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:scale-105"
//                     >
//                         <img
//                             src={`/${logo}`} // Ensure the correct path from public folder
//                             alt={`Client logo ${index + 1}`}
//                             className="h-12 sm:h-14 md:h-15 lg:h-15 xl:h-15 w-auto object-contain transition-transform duration-300 transform hover:scale-110"
//                         />
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default SocialProof;

import React from 'react';

// List of client logo paths (assuming icons are in public/cicons folder)
const clientLogos = [
  'cicons/logo1.png',
  'cicons/logo2.png',
  'cicons/logo3.png',
  'cicons/logo4.png',
  'cicons/logo5.png',
  'cicons/logo6.png',
  'cicons/logo7.png',
  'cicons/logo8.png',
  'cicons/logo9.png',
  'cicons/logo10.png',
  'cicons/logo11.png',
  'cicons/logo12.png',
  'cicons/logo13.png',
  'cicons/logo14.png',
  'cicons/logo15.png',
  'cicons/logo16.png',
];

const SocialProof = () => {
  return (
    <section className="py-16 px-6 sm:px-10 lg:px-16 bg-white">
      <div className="max-w-7xl mx-auto text-center">
        {/* Title */}
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-gray-800 tracking-tight mb-4">
          Trusted by Industry Leaders
        </h3>

        {/* Subtitle */}
        <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto mb-12">
          Join 20+ forward-thinking brands that partner with us to deliver better digital experiences.
        </p>

        {/* Client Logos Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 sm:gap-8 place-items-center">
          {clientLogos.map((logo, index) => (
            <div
              key={index}
              className="w-full h-20 flex items-center justify-center px-4 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition duration-300"
            >
              <img
                src={`/${logo}`}
                alt={`Client logo ${index + 1}`}
                className="h-12 sm:h-14 object-contain grayscale hover:grayscale-0 transition duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
